"use client";
import Lenis from 'lenis'
import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

/**
 *
 * @returns: En smooth scrolling funktion, der gør det muligt at scrolle jævnt på siden.
 * @example: <SmoothScrolling />
 * @alias: SmoothScrolling
 * @module: components/SmoothScrolling
 * @summary: Denne komponent bruges til at gøre det muligt at smooth scrolle.
 * @see: src/components/SmoothScrolling.tsx
 * @version: 1.0.0
 * @property: []
 
 * @author: Kasper Buchholtz
 *
**/


const SmoothScrolling = () => {
  const lenisRef = useRef<Lenis | null>(null);
  const pathname = usePathname();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      touchMultiplier: 2,
      lerp: 0.1,
    });
    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  // Reset scroll on route change so new pages don't inherit scroll position
  // from the previous page (Lenis hijacks scroll, so Next.js' default
  // scroll-to-top doesn't take effect on its own).
  useEffect(() => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    } else if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default SmoothScrolling;
